const handleNestedId = (id: string) => {
  const nestedId = id.split('.').pop();

  return nestedId;
};

export default handleNestedId;
